// A step failure propagates up to every ancestor, so a failure inside a loop marks the loop, its parent, and the run as
// failed too. Only the origin is worth flagging in the tree: a failed row with no failed descendant. Rows are a pre-order
// walk, so a row's descendants are the rows that follow it until depth returns to its own level.
const buildWorkflowRunFailureOrigins = (rows) => {
  if (!Array.isArray(rows)) {
    return [];
  }

  const origins = [];

  rows.forEach((row, position) => {
    if (row.statusVariant !== 'failure') {
      return;
    }

    for (let next = position + 1; next < rows.length && rows[next].depth > row.depth; next += 1) {
      if (rows[next].statusVariant === 'failure') {
        return;
      }
    }

    origins.push(row.index);
  });

  return origins;
};

export default buildWorkflowRunFailureOrigins;
